export const AUDIO_ON = require('./audioOn.png');
export const AUDIO_ON_HOVER = require('./audioOn.png');
export const AUDIO_OFF = require('./audioOff.png');
export const AUDIO_OFF_HOVER = require('./audioOff.png');
